import { Outlet } from 'react-router-dom';

import { AppLayout } from '@sorare/gameplay/src/components/navigation/AppLayout';

import { DailyClaimButton } from 'components/rewards/DailyClaimButton';

const Layout = () => (
  <AppLayout extraHeaderButton={<DailyClaimButton />}>
    <Outlet />
  </AppLayout>
);

export default Layout;
